import { render, staticRenderFns } from "./TraceabilityCollectionDateModal.vue?vue&type=template&id=687783cc&scoped=true"
import script from "./TraceabilityCollectionDateModal.vue?vue&type=script&lang=js"
export * from "./TraceabilityCollectionDateModal.vue?vue&type=script&lang=js"
import style0 from "./TraceabilityCollectionDateModal.vue?vue&type=style&index=0&id=687783cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687783cc",
  null
  
)

export default component.exports